import { render, staticRenderFns } from "./CustomerOnboarding.vue?vue&type=template&id=090a916a&scoped=true&"
import script from "./CustomerOnboarding.vue?vue&type=script&lang=js&"
export * from "./CustomerOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOnboarding.vue?vue&type=style&index=0&id=090a916a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a916a",
  null
  
)

export default component.exports